import React from 'react';
import { useSelector } from 'react-redux';

import { ExperimentId } from '../../../../../common/experiments/experimentsConstants';
import { getIsFeatureEnabledForCurrentUser } from '../../../../element/feature/elementFeatureSelector';
import { selectIsMobileAppMode } from '../../../../platform/platformSelector';
import { LoadableAccountModalRoot } from '../../accountModal/LoadableAccountModalComponents';
import { LoadableAccountSettingsV2Root } from './LoadableAccountSettingsV2Root';
import type { RouteComponentProps } from '../../../../../node_module_clones/react-router';

const accountSettingsV2EnabledSelector = getIsFeatureEnabledForCurrentUser(ExperimentId.accountSettingsV2);

const AccountSettingsRoute: React.FC<RouteComponentProps> = (props) => {
    const isMobile = useSelector(selectIsMobileAppMode);
    const isAccountSettingsV2Enabled = useSelector(accountSettingsV2EnabledSelector);

    const Component =
        isMobile || !isAccountSettingsV2Enabled ? LoadableAccountModalRoot : LoadableAccountSettingsV2Root;

    return <Component {...props} />;
};

export default AccountSettingsRoute;
